<template>
	<font-awesome-icon v-if="moral !== undefined && moral !== null" :icon="['fal', moral ? 'building' : 'building-user']" class="text-muted mr-1" />
</template>

<script type="text/javascript">
	/*
	 * Picto tiers moral (immeuble) / tiers physique (immeuble + personne).
	 * N'affiche rien si l'information tiers_moral n'est pas retournée.
	 * L'espace avant le nom du tiers vient de mr-1 : un &nbsp; serait supprimé par le
	 * compilateur de template (whitespace: condense), U+00A0 étant vu comme un blanc.
	 * La prop n'est pas typée : tiers_moral vaut selon la source un booléen ou un 0/1.
	 */
	export default {
		name: 'TiersMoralIcon',
		props: {
			moral: { default: null }
		}
	}
</script>
